import { render } from "./pagePagination.vue?vue&type=template&id=27891ec8&scoped=true"
import script from "./pagePagination.vue?vue&type=script&lang=js"
export * from "./pagePagination.vue?vue&type=script&lang=js"

import "./pagePagination.vue?vue&type=style&index=0&id=27891ec8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27891ec8"]])

export default __exports__